import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Label } from "src/app/labels/englishLabels";

export interface ConfirmData {
    title: string;
    content: string;
    positiveOptionText?: string;
    negativeOptionText?: string;
}

@Component({
    selector: "app-confirmation-dialog",
    templateUrl: "./confirmation-dialog.component.html",
    styleUrls: ["./confirmation-dialog.component.scss"],
})
export class ConfirmationDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmData,
    ) {
        data.positiveOptionText = data.positiveOptionText ?? Label.get("common.yes");
        data.negativeOptionText = data.negativeOptionText ?? Label.get("common.no");
    }

    public onClose(): void {
        this.dialogRef.close();
    }
}
